import { BS4ModalComponents } from "@core/components";
import { Controller } from "@hotwired/stimulus";
export default class ErrorController extends Controller {
    connect() {
        let notifierElement;
        if (this.hasNotifierTarget) {
            notifierElement = this.notifierTarget;
        }
        else {
            const modalElement = BS4ModalComponents.makeModalElement();
            modalElement.dataset[this.identifier + "Target"] = "notifier";
            this.element.appendChild(modalElement);
            notifierElement = modalElement;
        }
        this.notifier = new BS4ModalComponents.BS4ModalNotifier(notifierElement);
        this.notifier.setTitle(ErrorController.defaultTitle);
    }
    handleError({ detail }) {
        console.log(detail.error);
        if (detail.userNotification) {
            this._displayUserNotification(detail.userNotification);
        }
    }
    clearNotifications() {
        this.notifier.clear();
        this.notifier.setTitle(ErrorController.defaultTitle);
    }
    _displayUserNotification(userNotification) {
        if (userNotification.title) {
            this.notifier.setTitle(userNotification.title);
        }
        this.notifier.display(userNotification.message);
    }
}
ErrorController.targets = ["notifier"];
ErrorController.defaultTitle = "Error inesperado";
//# sourceMappingURL=error_controller.js.map